module.exports = __webpack_public_path__ + "static/kruticka3_orez-dcf7f7edac983a97f66c07cb7c7a02ae.png";